import { FaqData } from "../../../types/general";

export const FaqScreenMyMoneyData: FaqData[] = [
  {
    question: "Do I have to deposit funds?",
    answer:
      "No. Your assets remain at your disposal on the exchange. You can use them at any time to trade on your own without SMARD software.",
  },
];
